/**
 * Prompt Submission model
 */
export class PromptSubmission {
  constructor(data = {}) {
    this.title = data.title || '';
    this.persona = data.persona || '';
    this.format = data.format || '';
    this.context = data.context || '';
    this.task = data.task || '';
    this.dos = data.dos || '';
    this.donts = data.donts || '';
    this.examples = data.examples || '';
    this.category = data.category || '';
    this.backgroundTheory = data.backgroundTheory || '';
    this.description = data.description || '';
    this.promptText = data.promptText || '';
    this.unpaidCopilot = data.unpaidCopilot !== undefined ? data.unpaidCopilot : null;
  }

  /**
   * Create a PromptSubmission instance from data
   */
  static fromData(data) {
    return new PromptSubmission(data);
  }

  /**
   * Convert to plain object
   */
  toJSON() {
    return {
      title: this.title,
      persona: this.persona,
      format: this.format,
      context: this.context,
      task: this.task,
      dos: this.dos,
      donts: this.donts,
      examples: this.examples,
      category: this.category,
      backgroundTheory: this.backgroundTheory,
      description: this.description,
      promptText: this.promptText,
      unpaidCopilot: this.unpaidCopilot,
    };
  }
}

